<script>
	import { createEventDispatcher } from "svelte";

	import Form from "@svelteschool/svelte-forms";
	import TextField from "$lib/fields/TextField.svelte";
	import EmailField from "$lib/fields/EmailField.svelte";
	import PasswordField from "$lib/fields/PasswordField.svelte";
	import CheckboxField from "$lib/fields/CheckboxField.svelte";
	import Cellphone from "$lib/fields/Cellphone.svelte";

	export let values = {};

	export const validate = () => {
		for (const name in callbacks) {
			callbacks[name]?.();
		}
	};

	const required = ["name", "surname", "email", "terms", "password"];
	const dispatch = createEventDispatcher();
	let password_valid = false;
	let email_valid = false;
	let country_code = "";
	let cellphone_valid = false;

	const callbacks = {
		name: null,
		surname: null,
		email: null,
		password: null,
		cellphone_number: null,
		terms: null,
	};

	const validate_password = ({ detail }) => {
		password_valid = detail.valid;
	};

	const validate_email = ({ detail }) => {
		email_valid = detail.valid;
	};

	const validate_cellphone = ({ detail }) => {
		country_code = detail.code;
		cellphone_valid = detail.valid;
	};

	values.cellphone_number = ((n) => (n ? country_code + n : ""))(
		values.cellphone_number
	);

	$: values &&
		dispatch("validated", {
			form: "contact",
			code: country_code,
			validated:
				email_valid &&
				password_valid &&
				cellphone_valid &&
				required.every((key) =>
					key === "terms" ? values[key] : values[key]?.trim()
				),
		});
</script>

<Form bind:values>
	<TextField
		label="Name"
		name="name"
		maxlength="15"
		value={values.name ?? ""}
		bind:trigger={callbacks.name}
	/>

	<TextField
		label="Surname"
		name="surname"
		maxlength="20"
		value={values.surname ?? ""}
		bind:trigger={callbacks.surname}
	/>

	<EmailField
		label="Email Address"
		on:validate={validate_email}
		name="email"
		value={values.email ?? ""}
		bind:trigger={callbacks.email}
	/>

	<Cellphone
		value={values.cellphone_number ?? ""}
		on:validate={validate_cellphone}
		bind:trigger={callbacks.cellphone_number}
	/>

	<PasswordField
		label="Password"
		feedback={true}
		value={values.password ?? ""}
		on:validate={validate_password}
		bind:trigger={callbacks.password}
	/>

	<CheckboxField
		id="terms"
		checked={!!values.terms}
		bind:trigger={callbacks.terms}
	>
		I accept Qualimi's
		<a target="_blank" href="/terms-conditions2.php">Terms and Conditions</a>
	</CheckboxField>
</Form>
